import * as React from "react";
import Header from "../header-shared";
import Footer from "./footer";
export default class Layout extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: "store-template-b__wrap" },
            React.createElement(Header, { supplier: this.props.supplier }),
            React.createElement("div", { className: "Content store-template-b" }, this.props.children),
            React.createElement(Footer, null)));
    }
}
;
//# sourceMappingURL=layout.js.map